import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Prayer } from '../../models/prayer.model';
import { PrayerState, prayerAdapter } from '../reducers/prayer.reducer';

export const getPrayerState = createFeatureSelector<PrayerState>('prayers');
export const getIds = (state: PrayerState) => state.ids;
export const prayerStatsLoading = (state: PrayerState) =>
  state.prayerStatsLoading;
export const loading = (state: PrayerState) => state.loading;

export const {
  selectIds: getPrayerIds,
  selectEntities: getPrayerEntities,
  selectAll: getAllPrayers,
  selectTotal: getTotalPrayers,
} = prayerAdapter.getSelectors(getPrayerState);

export const getPrayersByGroupId = (groupId: string) =>
  createSelector(getAllPrayers, (allItems) => {
    // if (allItems) {
    return allItems
      .filter((item) => {
        return item.groupId === groupId;
      })
      .sort(sortDescendingByModifiedDate);
  });

function sortDescendingByModifiedDate(a: Prayer, b: Prayer): number {
  return a.modified.toDate() > b.modified.toDate()
    ? -1
    : a.modified.toDate() < b.modified.toDate()
    ? 1
    : 0;
}

export const getPrayerById = (prayerId: string) =>
  createSelector(getAllPrayers, (allItems) => {
    if (allItems) {
      return allItems.find((item) => {
        return item.id === prayerId;
      });
    } else {
      return null;
    }
  });
